import { clamp } from 'lodash';
import type { RenderInfoBuffer } from 'src/lib/player/RenderInfoManager';
import type { XY } from 'src/lib/player/store';
import type { Bounds } from '../InfoSheet/SVGChart';
import {
  DOT_RADIUS,
  MAX_DOT_COUNT,
  type ViewRange,
  getInterpolatedElevation,
  getInterpolatedY,
  isDataXInView,
  projectX,
} from './heightChartUtils';

export function HeightChartStarterDots({
  renderInfoBuffer,
  renderInfoOffset,
  renderInfoCount,
  bounds,
  viewRange,
  filteredTrack,
}: {
  renderInfoBuffer: RenderInfoBuffer;
  renderInfoOffset: number;
  renderInfoCount: number;
  bounds: Bounds;
  viewRange: ViewRange;
  filteredTrack: Array<XY>;
}) {
  const { minY, maxY } = viewRange;
  const output = [];
  const firstStarterIndex = clamp(renderInfoOffset, 0, renderInfoBuffer.length);
  const lastStarterIndex = clamp(
    renderInfoOffset + Math.min(MAX_DOT_COUNT, renderInfoCount),
    0,
    renderInfoBuffer.length,
  );

  for (let i = firstStarterIndex; i < lastStarterIndex; i++) {
    const offset = renderInfoBuffer.getOffset(i);
    const opacity = renderInfoBuffer.getOpacity(i);
    const fillOpacity = opacity / 255;
    if (
      renderInfoBuffer.getIsVisible(i) &&
      offset >= 0 &&
      !Number.isNaN(offset) &&
      opacity > 0 &&
      isDataXInView(offset, viewRange)
    ) {
      const starterDotX = projectX(offset, viewRange, bounds);
      const elevation = getInterpolatedElevation(filteredTrack, offset);
      const starterDotY = getInterpolatedY(elevation, minY, maxY, bounds);
      output.push(
        <circle
          key={i}
          cx={starterDotX}
          cy={starterDotY}
          r={DOT_RADIUS}
          fill={renderInfoBuffer.getColor(i)}
          stroke={renderInfoBuffer.getStrokeColor(i)}
          fillOpacity={fillOpacity}
        />,
      );
    }
  }
  return <>{output}</>;
}
